import React,{useState} from 'react'
import { Card, Space, Button,size} from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { InboxOutlined } from '@ant-design/icons';
import { Upload, message, Table } from 'antd';
import * as XLSX from 'xlsx';
import { baseURL } from '../store/api/axios';
import { encryptdata } from '../utils/encryptDecrypt';

const { Dragger } = Upload;

const LeadBulkUpload = () => {

  const [excelData, setExcelData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [excelFile, setExcelFile] = useState(null); // Store file

      
  const handleFile = (file) => {
    setExcelFile(file) // Store file
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      if (jsonData.length > 0) {
        const dynamicColumns = Object.keys(jsonData[0]).map((key) => ({
          title: key,
          dataIndex: key,
          key: key,
        }));

        setColumns(dynamicColumns);
        setExcelData(jsonData);
      } else {
        message.warning('No data found in the Excel file.');
      }
    };
    reader.readAsArrayBuffer(file);
    return false; // Prevent upload
  };
  const props = {
    beforeUpload: handleFile,
    multiple: false,
    showUploadList: false,
  };

  const handleDownloadExample = ()=>{
    fetch(`${baseURL}lead/download-template`)
    .then((response)=> {
        if(!response.ok) {
            throw new Error('Network response was ont ok');
        }
        return response.blob();
    })
    .then((blob)=>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Blaccdot_india_lead_template.xlsx';
        a.click();
        window.URL.revokeObjectURL(url)
    })
    .catch((error)=>{
        console.error('Download failed:', error);
    })
  }

  const hanldeSubmitBulkUpload = async ()=>{
   if(!excelFile){
     return message.warning('Please upload a file first');
   }

   const formData = new FormData();
   formData.append('lead_file', excelFile);



   try {
    const encrypt = encryptdata(formData)
    const response = await fetch(`${baseURL}lead/leadupload`,{
        method:'POST',
        body: encrypt,
    })

    console.log('formData',formData);
    
    if(!response.ok){
        throw new Error('Upload failed'); 
    }

        const result = await response.json(); 
    console.log('Server response:', result);
    
      message.success('Excel uploaded successfully!');
      setExcelData([]); // Optional: Clear preview
      setExcelFile(null);
      console.log('response',response);
    } catch (error) {
      console.log('Excel upload error:', error);
      message.error('Excel upload failed!');
    }


  }


  return (
    <div>
         <Card title="Lead Bulk upload" extra={
            <>
             <Button onClick={handleDownloadExample} shape="round" icon={<DownloadOutlined />}>
               Download Sample Template
              </Button>
            </> } style={{ width: '100%' }}>

                <div>
                  <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag Excel file to this area to upload</p>
                    <p className="ant-upload-hint">Only Excel files will be previewed below.</p>
                  </Dragger>
            
                  {excelData.length > 0 && (
                    <div style={{ marginTop: 20 }}>
                      <h5>Excel Preview </h5>
                      <Table dataSource={excelData}  columns={columns} rowKey={(record, index) => index}
                  scroll={{ x: 'max-content' }} pagination={{ pageSize: 10 }}/>       
                  <div style={{marginTop:'15px', justifyContent:'center', alignItems:'center',display:'flex'}}>
                    <Button onClick={hanldeSubmitBulkUpload} type='primary'>Upload Excel</Button>
                  </div>
                 </div>
             )}
           </div>
    </Card>
    </div>
  )
}

export default LeadBulkUpload